import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../Components/Pages/Home/Home';


function Routers() {
    return (
        <>
            <Routes>
                {/* Authentication Routes */}

                {/* Public Routes */}
                <Route path="/" element={<Home />} />

                {/* Protected Routes */}
               
            </Routes>
        </>
    );
}

export default Routers;
